
function getValueByPath(obj: any, path: string) {
    return path.split('.').reduce((o, key) => (o && o[key] !== undefined ? o[key] : ''), obj);
}

export function convertJSONToCSV(jsonData: any[], columnHeaders: any[],headerMapping:any) {
    // Check if JSON data is empty
    if (jsonData.length === 0) {
        return '';
    }

    // Create headers string
    const headers = columnHeaders
    .map((field) => headerMapping[field] || field)
    .join(',') + '\n';


    // Map JSON data to CSV rows
    const rows = jsonData
        .map((row) => {
            return columnHeaders.map((field) => {
                // Use getValueByPath to support nested keys
                const value = getValueByPath(row, field);
                // Escape double quotes by replacing them with two double quotes
                return `"${String(value).replace(/"/g, '""')}"`; 
            }).join(',');
        })
        .join('\n');


    // Combine headers and rows
    return headers + rows;
}


  // Function to initiate CSV download
export function downloadCSV(jsonData:any, headers:any[],headersMaping:any,fileName="Groove") {
    const csvData = convertJSONToCSV(jsonData, headers,headersMaping);
    // Check if CSV data is empty
    if (csvData === '') {
      alert('No data to export');
    } else {
      // Create CSV file and initiate download
      const blob = new Blob([csvData], { type: 'text/csv;charset=utf-8;' });
      const link = document.createElement('a');
      link.href = URL.createObjectURL(blob);
      link.setAttribute('download', `${fileName}.csv`);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
  }
